@use '@/styles/tokens' as *;

// Figma close button (node 131:1841): 24px round dismiss control.

.closeButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
  border: none;
  border-radius: 12px;
  background: $color-neutral-200;
  color: var(--text-primary);
  cursor: pointer;

  > svg {
    width: 14px;
    height: 14px;
  }

  &:hover:not(:disabled) {
    background: $color-control-hover;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
